module.exports = __webpack_public_path__ + "static/media/transportW.2520fd0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/transportW.svg
// module id = 548
// module chunks = 0